import { render, staticRenderFns } from "./StandaardStap.vue?vue&type=template&id=440c3566"
import script from "./StandaardStap.vue?vue&type=script&lang=js"
export * from "./StandaardStap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports